import { DianPurchase } from '@shared-models';

import { ProviderMapper } from './provider.mapper';
import { PurchaseItemMapper } from './purchase-item.mapper';

export class PurchaseMapper {
  static mapper(purchase: DianPurchase) {
    return {
      ...purchase,
      provider: ProviderMapper.mapper(purchase.provider),
      purchases: purchase.purchases.map((purchaseItem) => {
        return PurchaseItemMapper.mapper(purchaseItem);
      }),
    };
  }
}
